module.exports = __webpack_public_path__ + "media/images/favicon/safari-pinned-tab-4fad00fc6822a400307f69e8ef8bec82.svg";